module.exports = __webpack_public_path__ + "static/media/DWFuturaCyrillic.bd6bd359.woff2";